export const gearNames = [
    'Item_Bow',
    'Item_schnellebrille',
    'Item_Wings',
] as const
